import { CONFIG } from '../core/config';
import { ViewModel } from './view-model';

export interface UnitInterface {
  uomId: string;
  uomName: string;
  category: UoMCategory;
  sortOrder: number;
}

export class Unit implements ViewModel, UnitInterface {
  readonly friendlyTypeNameSingular = 'Unit of Measure';
  readonly apiRoute: string = CONFIG.apiRoutes.adminUnit;

  uomId: string;
  uomName: string;
  category: UoMCategory;
  sortOrder: number;
  categoryName: string;

  json(): any {
    return this;
  }

  loadFromJson(data) {
    this.uomId = data.uomId;
    this.uomName = data.uomName;
    this.category = data.category;
    this.sortOrder = data.sortOrder;
    this.categoryName = UoMCategory[data.category];
  }

  clone(): Unit {
    const clone = new Unit();
    clone.loadFromJson(this);
    return clone;
  }
}

export enum UoMCategory {
  Distance = 1,
  Weight = 2,
  Density = 3,
  Area = 4,
  Pressure = 5,
  Temperature = 6,
  Volume = 7,
  Energy = 8,
  TemperatureRate = 9,
  Angle = 10,
  RotationalSpeed = 11,
  Time = 12,
}
